import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function ProtectedRoute({ allowedRoles = [] }) {
  const { user, profile, loading, profileLoading, roleName } = useAuth()

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Loading...</p>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (profileLoading && !profile) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Loading your account...</p>
      </div>
    )
  }

  if (!profile) {
    return (
      <div className="banned-screen">
        <div className="banned-card">
          <h2>Account Unavailable</h2>
          <p>We could not load your account details. Please refresh and try again.</p>
        </div>
      </div>
    )
  }

  if (profile?.is_deleted) {
    return (
      <div className="banned-screen">
        <div className="banned-card">
          <h2>Account Suspended</h2>
          <p>Your account has been deactivated. Please contact the administrator.</p>
        </div>
      </div>
    )
  }

  if (
    allowedRoles.length > 0 &&
    roleName &&
    !allowedRoles.includes(roleName)
  ) {
    return (
      <div className="banned-screen">
        <div className="banned-card">
          <h2>Access Denied</h2>
          <p>You don't have permission to access this area. Your role: <strong>{roleName}</strong></p>
        </div>
      </div>
    )
  }

  return <Outlet />
}
